<template>
    <div class="querySystemCompare"  >
        <common-dialog :dialog-show="fglShow" :model-obj="modelObj" @closeDialog="closeDialog">
            <!--            favGroupList-->
            <div class="padding-b padding-x margin-top">
                <el-radio-group v-model="groupAlreadyCompare">
                    <el-radio  :border="true" v-for="(item,index) in favGroupList" :key="index" :label="item.favId" :disabled="item.isCompare">
                        <div class="text-default-color">
                            {{item.groupName}}
                        </div>
                        <div class="text-ellipsis text-secondary" :title="'该组合可报考'+item.majorPercent+'%的本、专科专业'">
                            {{'该组合可报考'+item.majorPercent+'%的本、专科专业'}}
                        </div>
                    </el-radio>
                </el-radio-group>
                <div class="text-center margin-y">
                    <el-button size="normal" @click="fglShow=false">取消</el-button>
                    <el-button size="normal" type="primary" @click="cancelCompare(groupAlreadyCompare,1)">确定</el-button>
                </div>
            </div>
        </common-dialog>
        <div class="titleBox delFloat padding-y">
            <div class="title text-default-color">科目组合对比</div>
            <div class="btn el-radio"  @click="mycollection">
                我收藏的组合
            </div>
        </div>
        <div>
            <div class="leftHead">
                <div class="topTitle">
                    <div class="son border commonShadow" @click="addSubjectGroup">
                        <span class="Fh">+</span>添加科目组合
                    </div>
                </div>
                <div class="headerTitle multiline">
                    <div>兴趣优势学科</div>
                    <div class="text-secondary">(依据学科测评)</div>
                </div>
                <div class="headerTitle multiline">
                    <div>潜能优势学科</div>
                    <div class="text-secondary">(依据学科测评)</div>
                </div>
                <div class="headerTitle multiline">
                    <div>学科要求</div>
                    <div class="text-secondary">(理解/背诵)</div>
                </div>
                <div class="headerTitle tag">
                    <div>文理偏向</div>
                </div>
                <div class="headerTitle tag">
                    <div>专业覆盖率</div>
                </div>
                <div class="categoryBox delFloat">
                    <div class="float-left">
                        <div>可报考门类比例</div>
                        <div>（本科）</div>
                    </div>
                    <div class="float-right">
                        <div v-for="(item,index) in categoryList" :key="index">{{item}}</div>
                    </div>
                </div>
                <div class="headerTitle tag">
                    <div>
                        是否可报考收藏的院校专业
                    </div>
                </div>
            </div>
            <div class="rightBoxContent position-relative">
                <div v-for="(item,index) in compareData" v-show="!compareLoading" :key="index" class="rightBoxSon">
                    <div class="topTitle ">
                        <div class="sonRight commonShadow position-relative border">
                            <div class="text-left padding-left text-secondary title">科目组合{{index+1}}:</div>
                            <div class="text-default-color content">{{item.groupName}}</div>
                            <div class="position-absolute el-icon-close" @click="cancelCompare(item.favId,2)">
                            </div>
                        </div>
                    </div>
                    <div class="headerTitle tag">
                        既无强兴趣也无弱兴趣
                    </div>
                    <div class="headerTitle tag">
                        既无强学科也无弱学科
                    </div>
                    <div class="headerTitle tag text-ellipsis padding-x" :title="item.subjectRequire">
                        {{item.subjectRequire}}
                    </div>
                    <div class="headerTitle tag text-ellipsis" :title="item.wldevelation">
                        {{item.wldevelation}}
                    </div>
                    <div class="headerTitle tag"  >
                        {{item.majorPercent+'%'}}
                    </div>
                    <div class="categoryBox possessContent">
                        <div v-for="(itemSon,index) in item.bTypePercent" :key="index">
                            {{itemSon.percent+'%'}}
                        </div>
                    </div>
                    <div class="headerTitle tag">
                        是
                    </div>
                </div>
                <loading :show="compareLoading"></loading>
            <empty v-show="compareData.length<1&&!compareLoading" :text-size="18" class="margin-medium-top" content="暂未添加相关对比组合"></empty>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        selectSubjectGetCompareGroupResult,
        selectSubjectOperateCompareGroups,
        selectSubjectUserGroupList
    } from "../../../../config";
    import {message} from 'element-ui'
    export default {
        name: "querySystemCompareSuper",
        // props:{
        //     //获取已收藏的组合列表
        //     favGroupList:Array
        // },
        data(){
            return{
                //获取组合列表已加入对比的组合
                groupAlreadyCompare:'',
                //门类列表
                categoryList:['哲学','经济学','法学','教育学','文学','历史学','理学',
                    '工学','农学','医学','管理学','艺术学'],
                //获取已添加的组合列表，及对比内容
                compareData:[],
                show:false,
                fglShow:false,
                modelObj:{
                    width:'1000px',
                    center:true,
                    title:'增加科目组合'
                },
                coverageData:[],
                compareLoading:false,
                favGroupList:[]
            }
        },
        mounted(){
            this.getCompareData();
        },
        methods:{

            //取消对比
            async cancelCompare(val,type){
                let result=await selectSubjectOperateCompareGroups(val,type);
                if(result.status){
                    this.fglShow=false;
                    console.log(result.data);
                    this.getCompareData();
                }
            },
            closeDialog(){
                this.fglShow=false;
            },
            //添加科目组合
            async addSubjectGroup(){
                let result=await selectSubjectUserGroupList();
                if(result.status){
                    console.log('我是收藏的组合 ');
                    console.log(result.data);
                    if(result.data.userFavGroups.length<1){
                        message({
                            message:'暂无收藏的学科组合',
                            type:'warning',
                            offset:300
                        });
                        return false;
                    }
                    this.favGroupList=result.data.userFavGroups;
                    this.fglShow=true;

                }
            },
            showGroupListCompare(){
                console.log('获取已收藏的组合列表');
                console.log(this.favGroupList);
                this.fglShow=true;

            },
            //获取对比结果
            async getCompareData(){
                this.show=true;
                this.compareLoading=true;
                let result=await selectSubjectGetCompareGroupResult();
                if(result.status){
                    this.compareLoading=false;
                    console.log('我是获取到的对比结果');
                    console.log(result.data);
                    this.compareData=result.data;
                }else{
                    this.compareLoading=false;
                }
            },
            mycollection(){
                this.show=false;
                this.$router.push({path:'/platform/querySystemCollection',query:{changePage:'fl'}});
            }

        }
    }
</script>
<style lang="scss">
    .querySystemCompare{
        .el-radio.is-bordered{

            height: 80px;
            padding-top:17px;
            .text-default-color{
                margin-bottom: 5px;
            }
        }
        .el-radio__label{
            float: left;

        }
        .el-radio__input{
            margin-left: 20px;
            float:right;
        }
    }
</style>

<style lang="scss" scoped>
    .querySystemCompare{
        position: relative;
        .titleBox{
            .title{
                font-size: 1.8em;
                font-weight: bolder;
                float: left;
            }
            .btn{
                font-size: 1.3em;
                float: right;
                border:1px solid #2b9dff;
                padding: 10px 20px 10px 20px;
                color:#2b9dff;
            }
        }
        .rightBoxContent{
            overflow: auto;
            padding-left: 191px;
            min-height: 899px;
            background: #ffffff;
            .rightBoxSon{
                width:192px;
                float: left;
                .headerTitle{
                    border-left: 0;
                }
                .categoryBox.possessContent{
                    >div {
                        border-left: 0;
                    }
                }
            }
        }
        .topTitle{
            width:192px;
            height:116px;
            padding: 10px;
            .son{
                cursor: pointer;
                text-align: center;
                line-height: 96px;
                height: 100%;
                font-size: 1.4em;
                color: #00a1ff;
                .Fh{
                    font-size: 1.4em;
                }
            }
            .sonRight{
                height: 100%;
                text-align: center;
                padding-top: 20px;
                .title{
                    font-size: 1.2em;
                    margin-bottom: 10px;
                }
                .content{
                    font-size: 1.3em;
                }
                .position-absolute{
                    font-size: 1.2em;
                    width:18px;
                    border-radius: 50%;
                    background: #b3b3b3;
                    color: #ffffff;
                    line-height: 18px;
                    height:18px;
                    top:-10px;
                    right:-10px;
                    cursor: pointer;
                }
            }
        }
        .headerTitle{
            width:192px;
            height:63px;
            border: 1px solid #e5e5e5;
            border-bottom: 0;
            text-align: center;
        }
        .headerTitle.tag{
            line-height: 63px;
        }
        .headerTitle.multiline{
            padding-top: 15px;
        }
        .headerTitle:nth-last-child(1){
            border-top:0;
            border-bottom: 1px solid #e5e5e5;
        }
        .categoryBox.possessContent{
            >div{
                width:192px;
                height:32px;
                border: 1px solid #e5e5e5;
                border-bottom: 0;
                text-align: center;
                line-height: 32px;
            }
            >div:nth-last-child(1){
                border-bottom: 1px solid #e5e5e5;
            }
        }
        .categoryBox{
            .float-left{
                padding-top: 150px;
                text-align: center;
                width: 125px;
                height:384px;
                border : 1px solid #e5e5e5;
                border-right:0;
            }
            .float-right{
                >div{
                    width:67px;
                    height:32px;
                    border: 1px solid #e5e5e5;
                    border-bottom: 0;
                    text-align: center;
                    line-height: 32px;
                }
                >div:nth-last-child(1){
                    border-bottom: 1px solid #e5e5e5;
                }
            }
        }
        .leftHead{
            position: absolute;
            top:auto;
            left: 0;
            z-index: 3;
            background-color: #fff;

        }
    }
</style>
